import { z } from "zod";
import { createAttribute } from "@coltorapps/builder";

export type TargetUrlMode = "fixed" | "expression";

export type TargetUrlAttributeValue =
  | string
  | {
      mode?: TargetUrlMode;
      value?: string;
      expression?: string;
    }
  | undefined;

export type NormalizedTargetUrlAttribute = {
  mode: TargetUrlMode;
  value?: string;
  expression?: string;
};

export function normalizeTargetUrlAttribute(
  value: TargetUrlAttributeValue,
): NormalizedTargetUrlAttribute {
  if (typeof value === "string") {
    return {
      mode: "fixed",
      value,
      expression: undefined,
    };
  }

  return {
    mode: value?.mode === "expression" ? "expression" : "fixed",
    value: value?.value,
    expression: value?.expression,
  };
}

export const targetUrlAttribute = createAttribute({
  name: "targetUrl",
  validate(value) {
    const targetUrlSchema = z.union([
      z.string(),
      z.object({
        mode: z.enum(["fixed", "expression"]).optional(),
        value: z.string().optional(),
        expression: z.string().optional(),
      }),
    ]);

    return targetUrlSchema.optional().parse(value);
  },
});
